import { useEffect, useRef } from "react";
import { useUser } from "../pages/login/UserContextPersistent";
import { registerPushNotifications } from "../utils/pushNotifications";

/**
 * Registers FCM token when an authenticated user is in the app (dashboard, etc.).
 * Covers refresh-token restore and cases where login-time registration did not finish.
 */
export default function PushNotificationBootstrap() {
  const { state } = useUser();
  const attemptedForUserRef = useRef(null);

  useEffect(() => {
    const userId = state.user?.id;
    if (!state.isAuthenticated || !userId) {
      return;
    }
    if (typeof Notification !== "undefined" && Notification.permission !== "granted") {
      return;
    }
    if (attemptedForUserRef.current === userId) {
      return;
    }
    attemptedForUserRef.current = userId;

    registerPushNotifications(userId).catch(() => {});
  }, [state.isAuthenticated, state.user?.id]);

  return null;
}
